<div class="card">
  <div class="card-body">

    <!-- DROPDOWN -->
    <div class="row mb-3">
      <div class="col-md-4">
        <label>Select Module</label>
        <select class="form-control"
                [(ngModel)]="selectedModule"
                (change)="loadGrid()">
          <option value="">-- Select --</option>
          <option *ngFor="let m of moduleList" [value]="m.R_Rightsid">
            {{ m.R_RightsName }}
          </option>
        </select>
      </div>
      <div class="col-md-4">
        <div class="text-md-start mt-3">
      <button class="btn btn-success" (click)="GetmenuGrid()">
        Show
      </button>
    </div>
      </div>
    </div>

    <!-- GRID -->
    <div class="table-responsive" *ngIf="gridData.length">
      <table class="table table-bordered table-sm">
        <thead>
          <tr>
            <th><input type="checkbox" [(ngModel)]="fullchecked" (change)="toggleAllCheckboxes()"></th>
            <th>Module Name</th>
            <th>Display Name</th>
            <th>Order</th>
            <th>Level</th>
            <th>Icon</th>
            <th>Router Link</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let row of gridData">
            <td>
              <input type="checkbox" [(ngModel)]="row.isChecked"  [checked]="row.MM_ID === row.MenuId || row.MM_Route_Link =='#'">
              <!-- <input *ngIf="row.WEB_MM_ID!=row.MenuId" type="checkbox" [(ngModel)]="row.isChecked=false"> -->
            </td>
            <td>{{ row.MM_Module }}</td>
            <td>
              <input class="form-control form-control-sm"
                     [(ngModel)]="row.MM_Display_Name">
            </td>
            <td>
              <input class="form-control form-control-sm"
                     [(ngModel)]="row.MM_Order_No">
            </td>
            <td>
              <input class="form-control form-control-sm"
                     [(ngModel)]="row.MM_Menu_Level">
            </td>
            <td>
              <input class="form-control form-control-sm"
                     [(ngModel)]="row.MM_Icon">
            </td>
            <td>
              <input class="form-control form-control-sm"
                     [(ngModel)]="row.MM_Route_Link">
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- SAVE -->
    <div class="text-end mt-3">
      <button class="btn btn-success" (click)="saveSelected()">
        Save
      </button>
    </div>

  </div>
</div>
